import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import AppLayout from './components/AppLayout';
import { TenantProvider } from './context/TenantContext';

// pages
import Login from './pages/Login';
import App from './App';
import LandingPage from './pages/LandingPage';
import ConsolidacaoDashboard from './pages/ConsolidacaoDashboard';
import SecretariaDashboard from './pages/SecretariaDashboard';
import CursosDashboard from './pages/CursosDashboard';
import DiscipuladoDashboard from './pages/DiscipuladoDashboard';
import GruposDashboard from './pages/GruposDashboard';
import JornadaDashboard from './pages/JornadaDashboard';
import VoluntariadoDashboard from './pages/VoluntariadoDashboard';
import FinanceiroDashboard from './pages/FinanceiroDashboard';
import CadastroAluno from './pages/CadastroAluno';
import CadastroProfessor from './pages/CadastroProfessor';
import CadastroConsolidador from './pages/CadastroConsolidador';
import FormularioVisitante from './pages/FormularioVisitante';
import AreaAluno from './pages/AreaAluno';
import HomeLanding from './pages/HomeLanding';
import Recursos from './pages/Recursos';
import AreaProfessor from './pages/AreaProfessor';
import AreaConsolidador from './pages/AreaConsolidador';
import AreaVoluntariado from './pages/AreaVoluntariado';
import GestaoVoluntariado from './pages/GestaoVoluntariado';
import AreaObreiros from './pages/AreaObreiros';
import ImportadorMembros from './pages/ImportadorMembros';
import CalendarioAulas from './pages/CalendarioAulas';
import MigracaoAlunos from './pages/MigracaoAlunos';
import Formandos from './pages/Formandos';
import CapturarCard from './pages/CapturarCard';
import GestaoConsolidadores from './pages/GestaoConsolidadores';
import GestaoVisitantes from './pages/GestaoVisitantes';
import RelatoriosConsolidacao from './pages/RelatoriosConsolidacao';
import Notificacoes from './pages/Notificacoes';
import NotificacoesCentro from './pages/notificacoes/NotificacoesCentro';
import MembrosSecretaria from './pages/MembrosSecretaria';
import Alunos from './pages/Alunos';
import Turmas from './pages/Turmas';
import Professores from './pages/Professores';
import Periodos from './pages/Periodos';
import Aulas from './pages/Aulas';
import AulaDetalhe from './pages/AulaDetalhe';
import Frequencias from './pages/Frequencias';
import Matriculas from './pages/Matriculas';
import Dashboard from './pages/Dashboard';
import Relatorios from './pages/Relatorios';
import Usuarios from './pages/Usuarios';
import AdminDashboard from './pages/AdminDashboard';
import AreaStartfy from './pages/AreaStartfy';
import CursosLista from './pages/cursos/CursosLista';
import CursoForm from './pages/cursos/CursoForm';
import CursoDetalhe from './pages/cursos/CursoDetalhe';
import InscricaoCurso from './pages/publico/InscricaoCurso';
import CriarGC from './pages/publico/CriarGC';
import DashboardCursos from './pages/cursos/DashboardCursos';
import InstrutoresLista from './pages/cursos/InstrutoresLista';
import DiscipuladoLista from './pages/discipulado/DiscipuladoLista';
import DiscipuladoForm from './pages/discipulado/DiscipuladoForm';
import DiscipuladoDetalhe from './pages/discipulado/DiscipuladoDetalhe';
import MeuDiscipulado from './pages/discipulado/MeuDiscipulado';
import GCLista from './pages/gcs/GCLista';
import GCForm from './pages/gcs/GCForm';
import GCDetalhe from './pages/gcs/GCDetalhe';
import GCDashboard from './pages/gcs/GCDashboard';
import GruposDiscipuladoLista from './pages/discipulado/GruposDiscipuladoLista';
import MaoAmiga from './pages/gcs/MaoAmiga';
import MaoCoracaoLista from './pages/maocoracao/MaoCoracaoLista';
import RelatoriosModulo from './pages/RelatoriosModulo';
import JornadaLista from './pages/jornada/JornadaLista';
import JornadaMembro from './pages/jornada/JornadaMembro';
import AlertasGestao from './pages/jornada/AlertasGestao';
import MeusCursos from './pages/MeusCursos';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import CadastroIgreja from './pages/CadastroIgreja';
import RedefinirSenha from './pages/RedefinirSenha';
import TenantCadastro from './pages/TenantCadastro';
import QuemSomos from './pages/QuemSomos';
import TermosUso from './pages/TermosUso';
import Privacidade from './pages/Privacidade';
import RegrasTeste from './pages/RegrasTeste';
import DashboardFinanceiro from './pages/financeiro/DashboardFinanceiro';
import LancamentosFinanceiro from './pages/financeiro/LancamentosFinanceiro';
import CategoriasFinanceiro from './pages/financeiro/CategoriasFinanceiro';
import ContasFinanceiro from './pages/financeiro/ContasFinanceiro';

function parseJwt(token) {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')));
  } catch {
    return null;
  }
}

function RequireRole({ roles, children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  const payload = parseJwt(token);
  const tipo = payload?.tipo;
  // Super admin e admin_tenant acessam todos os módulos do seu Tenant
  if (tipo === 'super_admin' || tipo === 'superadmin' || tipo === 'admin_tenant') return children;
  if (!roles || roles.length === 0) return children;
  if (roles.includes(tipo)) return children;
  if (tipo === 'aluno') return <Navigate to="/area-aluno" replace />;
  return <Navigate to="/home" replace />;
}

function Layout({ element }) {
  const token = localStorage.getItem('token');
  return (
    <>
      <PWAInstallPrompt />
      {token ? <AppLayout>{element}</AppLayout> : element}
    </>
  );
}

function HomeRedirect() {
  const token = localStorage.getItem('token');
  const payload = parseJwt(token);
  const tipo = payload?.tipo;
  if (tipo === 'aluno') return <Navigate to="/area-aluno" replace />;
  return <Navigate to="/home" replace />;
}

function HomePageWrapper() {
  const token = localStorage.getItem('token');
  const payload = parseJwt(token);
  // if user is guest (no token) show public LandingPage, otherwise show HomeLanding
  if (!payload) return <LandingPage />;
  return <HomeLanding />;
}

const routes = [
  { path: '/', element: <Navigate to="/home" replace /> },
  { path: '/login', element: <Layout element={<Login />} /> },
  { path: '/cadastro-aluno', element: <Layout element={<CadastroAluno />} /> },
  { path: '/cadastro-professor', element: <Layout element={<CadastroProfessor />} /> },
  { path: '/cadastro-consolidador', element: <Layout element={<CadastroConsolidador />} /> },
  { path: '/cadastrar-igreja', element: <Layout element={<CadastroIgreja />} /> },
  { path: '/redefinir-senha', element: <Layout element={<RedefinirSenha />} /> },
  { path: '/episcopal', element: <Layout element={<RequireRole roles={["super_admin"]}><SuperAdminDashboard /></RequireRole>} /> },
  { path: '/formulario-visitante', element: <Layout element={<FormularioVisitante />} /> },
  { path: '/inscrever-curso', element: <Layout element={<InscricaoCurso />} /> },
  { path: '/sugerir-gc', element: <Layout element={<CriarGC />} /> },
  { path: '/termos', element: <Layout element={<TermosUso />} /> },
  { path: '/privacidade', element: <Layout element={<Privacidade />} /> },
  { path: '/regras-teste', element: <Layout element={<RegrasTeste />} /> },
  { path: '/quem-somos', element: <Layout element={<QuemSomos />} /> },

  { path: '/area-aluno', element: <Layout element={<RequireRole roles={["aluno","admin"]}><AreaAluno /></RequireRole>} /> },
  { path: '/home', element: <Layout element={<HomePageWrapper />} /> },
  { path: '/consolidacao', element: <Layout element={<ConsolidacaoDashboard />} /> },
  { path: '/secretaria', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><SecretariaDashboard /></RequireRole>} /> },
  { path: '/cursos-dashboard', element: <Layout element={<CursosDashboard />} /> },
  { path: '/discipulado-dashboard', element: <Layout element={<DiscipuladoDashboard />} /> },
  { path: '/grupos-dashboard', element: <Layout element={<GruposDashboard />} /> },
  { path: '/jornada-dashboard', element: <Layout element={<JornadaDashboard />} /> },
  { path: '/voluntariado-dashboard', element: <Layout element={<VoluntariadoDashboard />} /> },
  { path: '/financeiro-dashboard', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><FinanceiroDashboard /></RequireRole>} /> },
  { path: '/recursos', element: <Layout element={<Recursos />} /> },
  { path: '/meus-cursos', element: <Layout element={<MeusCursos />} /> },

  { path: '/area-professor', element: <Layout element={<RequireRole roles={["professor","admin"]}><AreaProfessor /></RequireRole>} /> },
  { path: '/calendario-aulas', element: <Layout element={<RequireRole roles={["professor","admin"]}><CalendarioAulas /></RequireRole>} /> },

  { path: '/area-consolidador', element: <Layout element={<RequireRole roles={["consolidador","admin"]}><AreaConsolidador /></RequireRole>} /> },

  { path: '/admin', element: <Navigate to="/area-startfy" replace /> },
  { path: '/area-startfy', element: <Layout element={<RequireRole roles={["admin","professor","monitor"]}><AreaStartfy /></RequireRole>} /> },
  { path: '/alunos', element: <Layout element={<RequireRole roles={["admin"]}><Alunos /></RequireRole>} /> },
  { path: '/turmas', element: <Layout element={<RequireRole roles={["admin"]}><Turmas /></RequireRole>} /> },
  { path: '/professores', element: <Layout element={<RequireRole roles={["admin"]}><Professores /></RequireRole>} /> },
  { path: '/periodos', element: <Layout element={<RequireRole roles={["admin"]}><Periodos /></RequireRole>} /> },
  { path: '/aulas', element: <Layout element={<RequireRole roles={["admin"]}><Aulas /></RequireRole>} /> },
  { path: '/aulas/:id', element: <Layout element={<RequireRole roles={["admin", "aluno", "professor"]}><AulaDetalhe /></RequireRole>} /> },
  { path: '/frequencias', element: <Layout element={<RequireRole roles={["admin"]}><Frequencias /></RequireRole>} /> },
  { path: '/matriculas', element: <Layout element={<RequireRole roles={["admin"]}><Matriculas /></RequireRole>} /> },
  { path: '/dashboard', element: <Layout element={<RequireRole roles={["admin"]}><Dashboard /></RequireRole>} /> },
  { path: '/relatorios', element: <Layout element={<RequireRole roles={["admin"]}><Relatorios /></RequireRole>} /> },
  { path: '/usuarios', element: <Layout element={<RequireRole roles={["admin"]}><Usuarios /></RequireRole>} /> },
  { path: '/admin-dashboard', element: <Layout element={<RequireRole roles={["admin"]}><AdminDashboard /></RequireRole>} /> },

  { path: '/area-secretaria', element: <Navigate to="/secretaria" replace /> },
  { path: '/migracao-alunos', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><MigracaoAlunos /></RequireRole>} /> },
  { path: '/formandos', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><Formandos /></RequireRole>} /> },
  { path: '/importador-membros', element: <Layout element={<RequireRole roles={["secretaria"]}><ImportadorMembros /></RequireRole>} /> },
  { path: '/membros-secretaria', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><MembrosSecretaria /></RequireRole>} /> },
  { path: '/voluntariado', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><AreaVoluntariado /></RequireRole>} /> },
  { path: '/gestao-voluntariado', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><GestaoVoluntariado /></RequireRole>} /> },
  { path: '/obreiros', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><AreaObreiros /></RequireRole>} /> },

  { path: '/capturar-card', element: <Layout element={<RequireRole roles={["admin","consolidador"]}><CapturarCard /></RequireRole>} /> },
  { path: '/gestao-consolidadores', element: <Layout element={<RequireRole roles={["admin","consolidador"]}><GestaoConsolidadores /></RequireRole>} /> },
  { path: '/gestao-visitantes', element: <Layout element={<RequireRole roles={["admin","consolidador"]}><GestaoVisitantes /></RequireRole>} /> },
  { path: '/relatorios-consolidacao', element: <Layout element={<RequireRole roles={["admin","consolidador"]}><RelatoriosConsolidacao /></RequireRole>} /> },

  { path: '/notificacoes', element: <Layout element={<RequireRole roles={["admin","consolidador","professor","secretaria","pastor"]}><Notificacoes /></RequireRole>} /> },

  // ========== CURSOS ==========
  { path: '/cursos', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><CursosLista /></RequireRole>} /> },
  { path: '/cursos/novo', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><CursoForm /></RequireRole>} /> },
  { path: '/cursos/:id', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><CursoDetalhe /></RequireRole>} /> },
  { path: '/cursos/:id/editar', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><CursoForm /></RequireRole>} /> },
  { path: '/cursos/dashboard', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><DashboardCursos /></RequireRole>} /> },
  { path: '/cursos/instrutores', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><InstrutoresLista /></RequireRole>} /> },

  // ========== DISCIPULADO ==========
  { path: '/discipulados', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><DiscipuladoLista /></RequireRole>} /> },
  { path: '/discipulados/novo', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><DiscipuladoForm /></RequireRole>} /> },
  { path: '/discipulados/:id', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><DiscipuladoDetalhe /></RequireRole>} /> },
  { path: '/meu-discipulado', element: <Layout element={<RequireRole roles={[]}><MeuDiscipulado /></RequireRole>} /> },

  // ========== GRUPOS DE CRESCIMENTO ==========
  { path: '/grupos-crescimento', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><GCLista /></RequireRole>} /> },
  { path: '/grupos-crescimento/novo', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><GCForm /></RequireRole>} /> },
  { path: '/grupos-crescimento/:id', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><GCDetalhe /></RequireRole>} /> },
  { path: '/grupos-crescimento/:id/editar', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><GCForm /></RequireRole>} /> },
  { path: '/grupos-crescimento/dashboard', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><GCDashboard /></RequireRole>} /> },
  { path: '/discipulado-grupos', element: <Layout element={<RequireRole roles={["admin","admin_tenant","secretaria","pastor"]}><GruposDiscipuladoLista /></RequireRole>} /> },
  { path: '/mao-amiga', element: <Layout element={<RequireRole roles={["admin","admin_tenant","secretaria","pastor"]}><MaoAmiga /></RequireRole>} /> },
  { path: '/mao-coracao', element: <Layout element={<RequireRole roles={["admin","admin_tenant","secretaria","pastor"]}><MaoCoracaoLista /></RequireRole>} /> },
  { path: '/relatorios-modulo', element: <Layout element={<RequireRole roles={["admin","admin_tenant","secretaria","pastor"]}><RelatoriosModulo /></RequireRole>} /> },

  // ========== JORNADA ==========
  { path: '/jornada', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><JornadaLista /></RequireRole>} /> },
  { path: '/jornada/membro/:id', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><JornadaMembro /></RequireRole>} /> },
  { path: '/jornada/alertas', element: <Layout element={<RequireRole roles={["admin","pastor","secretaria"]}><AlertasGestao /></RequireRole>} /> },

  // ========== FINANCEIRO ==========
  { path: '/financeiro', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><DashboardFinanceiro /></RequireRole>} /> },
  { path: '/financeiro/lancamentos', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><LancamentosFinanceiro /></RequireRole>} /> },
  { path: '/financeiro/categorias', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><CategoriasFinanceiro /></RequireRole>} /> },
  { path: '/financeiro/contas', element: <Layout element={<RequireRole roles={["secretaria","pastor"]}><ContasFinanceiro /></RequireRole>} /> },

  // ========== NOTIFICAÇÕES CENTRO ==========
  { path: '/notificacoes-centro', element: <Layout element={<RequireRole roles={["admin","secretaria","pastor"]}><NotificacoesCentro /></RequireRole>} /> },

  // ========== TENANT ROUTES ==========
  { path: '/t/:slug', element: <Layout element={<TenantProvider><HomeLanding /></TenantProvider>} /> },
  { path: '/t/:slug/login', element: <Layout element={<TenantProvider><Login /></TenantProvider>} /> },
  { path: '/t/:slug/cadastro', element: <Layout element={<TenantProvider><TenantCadastro /></TenantProvider>} /> },
  { path: '/t/:slug/home', element: <Layout element={<TenantProvider><HomeLanding /></TenantProvider>} /> },
  { path: '/t/:slug/financeiro', element: <Layout element={<TenantProvider><RequireRole roles={["secretaria","pastor"]}><DashboardFinanceiro /></RequireRole></TenantProvider>} /> },
  { path: '/t/:slug/episcopal', element: <Layout element={<TenantProvider><RequireRole roles={["super_admin"]}><SuperAdminDashboard /></RequireRole></TenantProvider>} /> },
  { path: '/t/:slug/*', element: <Layout element={<TenantProvider><HomeLanding /></TenantProvider>} /> },

  // fallback
  { path: '*', element: <Layout element={<HomeRedirect />} /> },
];

const router = createBrowserRouter(routes, {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

export default function AppRouterProvider() {
  return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
}
